import React, { useEffect, useState, createContext, useContext, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const CompanyContext = createContext(null);

export function useCompany() {
  return useContext(CompanyContext) || { company: null, loading: true, refresh: () => {} };
}

export function hasFeature(company, feature) {
  if (!company) return false;
  if (!feature) return true;
  return Array.isArray(company.features) && company.features.includes(feature);
}

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user || !user.company_id) {
      setCompany(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/api/companies/me`, { withCredentials: true });
      setCompany(data);
    } catch {
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <CompanyContext.Provider value={{ company, loading, refresh }}>
      {children}
    </CompanyContext.Provider>
  );
}
